// kogas(가스공사) 전용 회원가입 옵션 — DB 마스터테이블 미사용, FE 하드코딩.
// 선택값 자체는 identity_user.role / identity_user.type 컬럼에 저장됨.
// 활성화는 빌드 env VUE_APP_TENANT=kogas 로 토글( vue-cli-service build --mode kogas ).

export const IS_KOGAS = process.env.VUE_APP_TENANT === "kogas";

// role: 관리자와 실사용자 구분 (identity_user.role)
export const KOGAS_ROLES = [
  { value: "USER", label: "사용자" },
  { value: "ADMIN", label: "점검앱 관리자" },
  { value: "SYSTEM", label: "시스템 관리자 / 개발자" },
];

// type: 점검앱 구분 (identity_user.type). role=USER 일 때만 사용, ADMIN/SYSTEM 은 null.
export const KOGAS_TYPES = [
  { value: "TYPE_1", label: "충전소 운영 사업자" },
  { value: "TYPE_2", label: "점검원" },
  { value: "TYPE_3", label: "제조사 점검 직원" },
  { value: "TYPE_4", label: "kogas-tech 점검 인력" },
];

// ── 회원가입 화면 표시 필터 (값은 위 전체 유지, 화면엔 아래만 노출) ──
// 현재 정책: 역할=USER 고정, 구분=운영 사업자/점검원만.
// 나중에 다른 값을 열려면 이 배열에 value 만 추가하면 됨.
export const KOGAS_ROLE_FILTER = ["USER"];
export const KOGAS_TYPE_FILTER = ["TYPE_1", "TYPE_2"];

// kogas 빌드에서 소속 드롭다운을 이 회사코드로만 제한 (master_company.CompanyCode).
export const KOGAS_COMPANY_CODE = "KOGAS";

// TYPE 코드 → 라벨 매핑 (회원가입·이력 등 공용, TYPE_1~4 전체).
// 데이터가 소문자(type_2)로 올 수 있어 대문자로 정규화 후 매칭. 미매칭이면 원본 값 반환.
export function typeLabel(value) {
  if (value == null) return "";
  const key = String(value).toUpperCase();
  const found = KOGAS_TYPES.find((t) => t.value === key);
  return found ? found.label : value;
}
